import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/FeatureHighlight.css';

const teams = [
  { name: 'Team A',  score: '4.8/5', colour: 'green',  badge: '↑', bgHex: '#1ab02a' },
  { name: 'Team B',  score: '4.2/5', colour: 'blue',   badge: '↑', bgHex: '#3fb9eb' },
  { name: 'Team C',  score: '3.9/5', colour: 'orange', badge: '↓', bgHex: '#ffa405' },
];

const barHeights = [40, 65, 55, 80, 70, 90, 75];

function FeatureHighlight() {
  return (
    <section className="feature-highlight">
      <div className="section-container">
        <div className="feature-highlight-grid">

          {/* Dashboard mockup */}
          <div className="dashboard-mockup">
            <div className="mockup-titlebar">
              <div className="mockup-dot" style={{ background: '#ef4444' }} />
              <div className="mockup-dot" style={{ background: '#f59e0b' }} />
              <div className="mockup-dot" style={{ background: '#22c55e' }} />
              <span className="mockup-titlebar-label">Zella Dashboard</span>
            </div>

            <div className="mockup-body">
              {/* Stats */}
              <div className="mockup-stats">
                <div className="mockup-stat green">
                  <div className="mockup-stat-value green">3113</div>
                  <div className="mockup-stat-label">Total Surveys</div>
                </div>
                <div className="mockup-stat blue">
                  <div className="mockup-stat-value blue">2.34/5</div>
                  <div className="mockup-stat-label">Avg Tiredness</div>
                </div>
                <div className="mockup-stat orange">
                  <div className="mockup-stat-value orange">4.0/5</div>
                  <div className="mockup-stat-label">Avg Happiness</div>
                </div>
              </div>

              {/* Team list */}
              <div className="mockup-list-title">Top Performing Teams</div>
              {teams.map(({ name, score, colour, badge, bgHex }) => (
                <div key={name} className="mockup-team-row">
                  <span className="mockup-team-name">{name}</span>
                  <span className={`mockup-team-score ${colour}`}>{score}</span>
                  <span
                    className="mockup-team-badge"
                    style={{ background: `${bgHex}22`, color: bgHex }}
                  >
                    {badge}
                  </span>
                </div>
              ))}

              {/* Bar chart */}
              <div className="mockup-chart">
                {barHeights.map((h, i) => (
                  <div
                    key={i}
                    className="mockup-bar"
                    style={{
                      height: `${h}%`,
                      background: i === 5 ? '#1ab02a' : '#1ab02a55',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="feature-text">
            <div className="section-tag">Dashboard</div>
            <h2>
              Manage the wellbeing of your workforce{' '}
              <span className="highlight-blue">in one place</span>
            </h2>
            <p>
              Monitor team wellbeing trends, identify pressure points, and make
              data-driven decisions with Zella's all-in-one insights dashboard.
            </p>

            <ul className="feature-checklist">
              {[
                'Anonymised group data',
                'Real-time trend analysis',
                'Happiness & tiredness metrics',
                'Policy impact measurement',
              ].map((item) => (
                <li key={item}>
                  <span className="check-circle">
                    <svg viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link to="/signup" className="btn-primary">Try it out today</Link>
          </div>

        </div>
      </div>
    </section>
  );
}

export default FeatureHighlight;
